import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { ProjectDiagramTileId } from 'src/constants/mosaic';
import { PROJECT_DIAGRAM_RESCALE_PARAM } from 'src/constants/project';
import { ProjectDiagramModelList } from 'src/containers/ProjectDiagram/components/modelList/ProjectDiagramModelList';
import { useContextMenu } from 'src/containers/ProjectDiagram/hooks/useContextMenuValue';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ProjectDiagramContainer } from 'src/containers/ProjectDiagram/ProjectDiagramContainer';
import { redrawLayout } from 'src/containers/ProjectDiagram/templates/extensions/layouts/utils/redrawLayout';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { ProjectAutoGenerateRunner } from 'src/containers/ProjectResourceSuggestionsDialog/ProjectAutoGenerateRunner';
import { pendingAutoGenerateMockDataSelector } from 'src/selectors/pendingAutoGenerateMockData';
import { pendingAutoGenerateResourceIdsSelector } from 'src/selectors/pendingAutoGenerateModel';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const ProjectDiagramView = () => {
  const { projectId } = useRouterParams();
  const [contextMenu, setContextMenu] = useContextMenu();
  const diagram = useDiagram();
  const history = useHistory();
  const isModelListOpen = useReduxSelector(
    (state) => state.ui.modelList.isOpen
  );

  // Handle auto-model generation from create project flow
  const hasPendingAutoGenerate = useReduxSelector((state) =>
    Boolean(
      pendingAutoGenerateResourceIdsSelector(projectId)(state)?.length ||
        pendingAutoGenerateMockDataSelector(projectId)(state)
    )
  );

  React.useEffect(() => {
    const { search, pathname } = history.location;
    const params = new URLSearchParams(search);

    if (
      params.has(PROJECT_DIAGRAM_RESCALE_PARAM) &&
      diagram &&
      !diagram.headless
    ) {
      history.replace(pathname);
      commitDiagramWhileSkippingUndoManager(diagram, redrawLayout);
    }
  }, [diagram, history]);

  return (
    <div className="sd-project-diagram-view">
      <ProjectDiagramContainer
        contextMenu={contextMenu}
        id={ProjectDiagramTileId.VIEW}
        onContextMenuClose={() => {
          setContextMenu(null);
          // return focus to gojs
          if (diagram && !diagram.headless) {
            diagram.toolManager.contextMenuTool.doCancel();
          }
        }}
      />
      {isModelListOpen ? <ProjectDiagramModelList /> : null}
      {hasPendingAutoGenerate ? <ProjectAutoGenerateRunner /> : null}
    </div>
  );
};
